export class PaginatableCollection {
  constructor(sortColumn) {
    this.collection = [];
    this.limit = 20;
    this.page = 0;
    this.canLoad = true;
    this.initialized = false;
    this.total = 0;
    this.sortColumn = sortColumn;
    this.sortDirection = 0;
  }
};